"use client";

import { useState } from "react";
import { MethodBadge } from "./MethodBadge";
import { copyToClipboard } from "../lib/copy";

type Method = "GET" | "POST" | "PUT" | "PATCH" | "DELETE";

export function Endpoint({
  method,
  path,
  baseUrl = "https://api.circa.ai",
}: {
  method: Method;
  path: string;
  baseUrl?: string;
}) {
  const [copied, setCopied] = useState(false);
  const full = `${baseUrl}${path}`;

  const copy = async () => {
    const ok = await copyToClipboard(full);
    if (ok) {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    }
  };

  return (
    <div className="not-prose flex items-center gap-3 rounded-lg border border-border bg-surface px-3 py-2.5 my-6">
      <MethodBadge method={method} />
      <code className="font-mono text-sm text-text-primary flex-1 truncate">
        {path}
      </code>
      <button
        type="button"
        onClick={copy}
        className="text-xs text-text-secondary hover:text-accent transition-colors cursor-pointer"
      >
        {copied ? "Copied" : "Copy"}
      </button>
    </div>
  );
}
